import { newsArticles } from '../../../mocks/news';
import { openRandomPlayLink } from '../../../config/playLinks';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../router/routes';

export default function NewsSection() {
  const handleOpenPartner = () => {
    openRandomPlayLink();
  };

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Latest Casino News</h2>
          <p className="text-md text-gray-600">Stay informed with the latest industry updates and insights</p>
        </div>

        <div className="space-y-6">
          {newsArticles.map((article, index) => (
            <article
              key={index}
              role="button"
              tabIndex={0}
              onClick={handleOpenPartner}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleOpenPartner()}
              className="group bg-white border border-gray-200 rounded-lg hover:shadow-md transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="flex flex-col md:flex-row">
                <div className="relative md:w-80 h-48 md:h-auto overflow-hidden flex-shrink-0">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 bg-green-600 text-white px-3 py-1 rounded text-xs font-semibold uppercase">
                    {article.category}
                  </div>
                </div>
                
                <div className="flex-1 p-4 sm:p-6">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-gray-500 mb-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      <span>{article.date}</span>
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      <span>{article.readTime}</span>
                    </span>
                    <span className="text-gray-400">•</span>
                    <span className="text-gray-700 font-medium">{article.author}</span>
                  </div>
                  
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 group-hover:text-green-700 transition-colors">
                    {article.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 leading-relaxed">{article.excerpt}</p>
                  
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenPartner();
                    }}
                    className="inline-flex items-center min-h-[44px] text-green-700 font-semibold hover:text-green-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Read Full Article
                    <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to={ROUTES.newsGuides}
            className="inline-flex min-h-[44px] px-6 sm:px-8 py-3 bg-white border-2 border-gray-300 text-gray-900 font-semibold rounded-lg hover:border-green-600 hover:text-green-700 transition-all whitespace-nowrap cursor-pointer"
          >
            View All News Articles
          </Link>
        </div>
      </div>
    </section>
  );
}